export const iconFontAwesomeBuildingsHouseCircleCheck = (
	<i className="fa-solid fa-house-circle-check"></i>
);
